module.exports = __webpack_public_path__ + "static/img/IMG_20160307_145749.cbe90e7d.jpg";